import { Action } from 'redux'
import { UpdatePasswordActions } from '../../../reducers/userAccount/actionNames'

export const updatePassword = (password: string): IUpdatePassword => ({
  password,
  type: UpdatePasswordActions.UpdatePassword,
})

export const validateOldPassword = (
  oldPassword: string,
  newPassword: string,
): IValidateOldPassword => ({
  newPassword,
  oldPassword,
  type: UpdatePasswordActions.ValidateOldPassword,
})

export const passwordUpdated = (): IPasswordUpdated => ({
  type: UpdatePasswordActions.PasswordUpdated,
})

export const passwordRejected = (): IPasswordRejected => ({
  type: UpdatePasswordActions.PasswordRejected,
})

export interface IUpdatePassword
  extends Action<UpdatePasswordActions.UpdatePassword> {
  password: string
}

export interface IValidateOldPassword
  extends Action<UpdatePasswordActions.ValidateOldPassword> {
  oldPassword: string
  newPassword: string
}

export type IPasswordUpdated = Action<UpdatePasswordActions.PasswordUpdated>
export type IPasswordRejected = Action<UpdatePasswordActions.PasswordRejected>
